import {createSlice} from "@reduxjs/toolkit";
import {ILanguage} from "../../../models/Llanguage";
import {readLanguageFromPath} from "../../../config/languages";


/**
 * Derived from the URL prefix and never mutated: switching language is a full
 * page load onto the new prefix, so there is nothing left to keep in sync.
 */
const initialState: ILanguage = {
    language: readLanguageFromPath(window.location.pathname).language
}

export const languageSlice = createSlice({
    name: 'language',
    initialState,
    reducers: {},
})


export const languageReducer = languageSlice.reducer
